export default "__VITE_ASSET__Bx0APO3u__"